export default __webpack_public_path__ + "bull-horn-announcer.png";